// extracted by mini-css-extract-plugin
export default {"visuallyhidden":"excel-mappings-item__visuallyhidden--B1Yr3","focusable":"excel-mappings-item__focusable--OBb6q","container":"excel-mappings-item__container--GLDsn"};